import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
const {
  reportTemplate: { path },
} = routes;
const ReportTemplateRoute = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./ReportTemplate"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
export default ReportTemplateRoute;
